var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-container credit-application",attrs:{"id":"application-component"}})
}
var staticRenderFns = []

export { render, staticRenderFns }